<template>
  <div :class="{ 'ligneLienCommande__general' : isEdition}">
    <div class="infoCommande columns has-text-default">
      <div class="column is-narrow pdr-5px">
        {{ $t('editionFacture.ligne.linkCommande')}}
      </div>
      <router-link-blank :to="{ name: 'c.bodac.commandes',
        params: { id: ligneCommande.commandeId }}"
                         class="lien column is-narrow pdl-0"
                         :class="{'text-access-no-permission':
                     !checkPermissions(constantes.COMMANDES.lecture)}"
                         :message="getCodeCommande">
      </router-link-blank>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { COMMANDES } from '@/configuration/permissionsBodacConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
    referencesCommande: {
      type: Array,
      required: true,
    },
    isEdition: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      constantes: {
        COMMANDES,
      },
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getCodeCommande() {
      const commandes = this.referencesCommande.find((ref) => {
        return ref.id === this.ligneCommande.commandeId;
      });
      return commandes ? commandes.code : '';
    },
  },
};
</script>
